import moment from 'moment'

import { vehiclesEntityToArray } from 'dashboard-subscriptions/utils'

import styles from 'dashboard-subscriptions/components/styles.module.scss'

const getVehiclesList = fieldMap => {
    const vehicles = vehiclesEntityToArray(fieldMap)?.filter(v => !v.isDeleted)
    if (vehicles) {
        return vehicles.map((v, i) => (
            <span key={i}>
                {v.tag}
                {i < vehicles.length - 1 ? ', ' : ''}
            </span>
        ))
    }

    return null
}

const ParkerListItemOccupied = ({ member }) => (
    <div className={styles.productDetails}>
        <span>{member.products[0].ratePlanName}</span>
        <span className="mt-1">
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.plan.name</T>:{' '}
            </span>
            <span>{member.products[0].productName}</span>
        </span>
        <span className="mt-1">
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.start</T>:{' '}
            </span>
            <span>{moment(member.startDate).format('MM/DD/YYYY')}</span>
        </span>
        {member.endDate && (
            <span className="mt-1">
                <span className={styles.lineDescription}>
                    <T>dashboard.subscriptions.products.label.end</T>:{' '}
                </span>
                <span>{moment(member.endDate).format('MM/DD/YYYY')}</span>
            </span>
        )}
        <span className="mt-1">
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.parker.name</T>:{' '}
            </span>
            <span>{`${member.firstName} ${member.lastName}`}</span>
        </span>
        {member.emailAddress && (
            <span className="mt-1">
                <span className={styles.lineDescription}>
                    <T>dashboard.subscriptions.products.label.email</T>:{' '}
                </span>
                <span>{member.emailAddress}</span>
            </span>
        )}
        <span className="mt-1">
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.vehicles</T>:{' '}
            </span>
            <span>{getVehiclesList(member)}</span>
        </span>
    </div>
)

export default ParkerListItemOccupied
